/**
 * Actions Types
 */

export enum EnderecoTypes {
  ENDERECO_REQUEST = '@refinanciamento/endereco/ENDERECO_REQUEST',
  ENDERECO_SUCCESS = '@refinanciamento/endereco/ENDERECO_SUCCESS',
  ENDERECO_LOADING = '@refinanciamento/endereco/ENDERECO_LOADING',
  ENDERECO_ERROR = '@refinanciamento/endereco/ENDERECO_ERROR',

  SET_CEP = '@refinanciamento/endereco/SET_CEP',
  SET_TIPO_LOGRADOURO = '@refinanciamento/endereco/SET_TIPO_LOGRADOURO',
  SET_LOGRADOURO = '@refinanciamento/endereco/SET_LOGRADOURO',
  SET_BAIRRO = '@propsota/endereco/SET_BAIRRO',
  SET_NUMERO = '@refinanciamento/endereco/SET_NUMERO',
  SET_COMPLEMENTO = '@refinanciamento/endereco/SET_COMPLEMENTO',
  SET_UF = '@refinanciamento/endereco/SET_UF',
  SET_CIDADE = '@refinanciamento/endereco/SET_CIDADE',
  RESET = 'RESET',
}

/**
 * Data Types
 */

export interface Endereco {
  cep: string
  tipoLogradouro: string
  logradouro: string
  bairro: string
  uf: string
  cidade: string
}

/**
 * Address Type
 */

export interface EnderecoState {
  readonly endereco: Endereco[]
  readonly enderecoError: boolean
  readonly enderecoLoading: boolean

  readonly cep: string
  readonly tipoLogradouro: string
  readonly logradouro: string
  readonly bairro: string
  readonly numero: string
  readonly complemento: string
  readonly uf: string
  readonly cidade: string
}

export interface EnderecoPayload {
  cep: string
  callback?: (endereco?: Endereco) => void
}
